module.exports = __webpack_public_path__ + "img/superior.f2ca2b95.png";